export default __webpack_public_path__ + "static/media/whirlwind3.95dd2333.png";